import { reactive, watchEffect, computed } from "vue";
import { u as useEvent } from "../../../composables/useEvent-d1ae925d.mjs";
const useCursorAnchor = (anchorRef, noUpdate) => {
  const mouse = reactive({ x: 0, y: 0 });
  useEvent(["mousemove", "mousedown", "mouseup"], (e) => {
    const { x, y } = anchorRef.value.getBoundingClientRect();
    mouse.x = e.clientX - x;
    mouse.y = e.clientY - y;
  }, anchorRef);
  const mouseOffset = {
    x: 0,
    y: 0
  };
  watchEffect(() => {
    if (noUpdate.value) {
      return;
    }
    mouseOffset.x = mouse.x;
    mouseOffset.y = mouse.y;
  });
  return computed(() => {
    if (!anchorRef.value) {
      return void 0;
    }
    const target = anchorRef.value;
    const getBoundingClientRect = () => {
      const rect = target.getBoundingClientRect();
      const x = rect.left + mouseOffset.x;
      const y = rect.top + mouseOffset.y;
      return {
        ...rect,
        x,
        y,
        bottom: y + 1,
        right: x + 1,
        left: x,
        top: y
      };
    };
    return new Proxy(target, {
      get(target2, key) {
        if (key === "getBoundingClientRect") {
          return getBoundingClientRect;
        }
        return target2[key];
      }
    });
  });
};
export {
  useCursorAnchor as u
};
//# sourceMappingURL=useCursorAnchor-23b1a013.mjs.map
